import Slider from '../modules/slider';
import Widget from '../modules/widget';
import Dropdown from '../modules/dropdown';

export default {
  init() {

    // PRODUCENT SLIDER DESKTOP

    new Slider('.js-producers-slider-1', {
      direction: 'horizontal',
      slidesPerView: 1,
      clickableState: true,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    // PRODUCENT SLIDER MOBILE

    new Slider('.js-producers-slider-2', {
      direction: 'horizontal',
      slidesPerView: 1,
      clickableState: true,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    // CATEGORY WIDGET ON MOBILE
    const categoryWidget = new Widget('.widget_product_categories', '.js-open-category-widget', 'widget-opened');
    categoryWidget.toggleWidget();

    // CATEGORY WIDGET - SUBCATEGORIES DROPDOWN
    const categoryChildrenDropdown = new Dropdown('.cat-parent', 'subcategory-opened');
    categoryChildrenDropdown.initStateOpen();
    categoryChildrenDropdown.toggleDropdown();
  },

  finalize() {

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/archive.js